import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Calculator, Plus, Package } from "lucide-react";
import { PartCard } from "./PartCard";

export function OrderBuilder({ 
  doors, 
  doorStyles, 
  units, 
  onUnitsChange, 
  onAddDoor, 
  onUpdateDoor, 
  onDeleteDoor, 
  onViewImage 
}) {
  // Group styles by category for the select dropdown
  const stylesByCategory = {};
  Object.keys(doorStyles).forEach((key) => {
    const style = doorStyles[key];
    const cat = style.category || "Other";
    if (!stylesByCategory[cat]) stylesByCategory[cat] = [];
    stylesByCategory[cat].push({ key, ...style });
  });

  return (
    <Card className="border-gray-200">
      <CardHeader className="bg-gray-50 border-b border-gray-200">
        <div className="flex justify-between items-center">
          <CardTitle className="flex gap-2 text-[#6A7359] font-sans">
            <Calculator className="w-5 h-5" />
            Build Your Order
          </CardTitle>
          <div className="flex items-center gap-2">
            {/* Units Toggle */}
            <div className="flex items-center bg-white rounded-md border border-gray-200 text-xs">
              <button 
                onClick={() => onUnitsChange("imperial")} 
                className={"px-2 py-1 rounded-l-md transition-colors " + 
                  (units === "imperial" ? "bg-[#6A7359] text-white" : "text-gray-600 hover:bg-gray-100")} 
                data-testid="units-imperial"
              >
                in
              </button>
              <button 
                onClick={() => onUnitsChange("cm")} 
                className={"px-2 py-1 transition-colors " + 
                  (units === "cm" ? "bg-[#6A7359] text-white" : "text-gray-600 hover:bg-gray-100")} 
                data-testid="units-cm"
              >
                cm
              </button>
              <button 
                onClick={() => onUnitsChange("mm")} 
                className={"px-2 py-1 rounded-r-md transition-colors " + 
                  (units === "mm" ? "bg-[#6A7359] text-white" : "text-gray-600 hover:bg-gray-100")} 
                data-testid="units-mm"
              >
                mm
              </button>
            </div>
            <Button 
              onClick={onAddDoor} 
              size="sm" 
              className="bg-[#6A7359] hover:bg-[#565E48] font-sans" 
              data-testid="add-door-btn"
            >
              <Plus className="w-4 h-4 mr-1" />
              Add Part
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-4">
        {doors.length === 0 ? (
          <div className="text-center py-8 text-gray-400">
            <Package className="w-10 h-10 mx-auto mb-2 opacity-50" />
            <p>No parts yet</p>
            <p className="text-sm">Use AI chat or click Add Part</p>
          </div>
        ) : (
          <div className="space-y-4">
            {doors.map((door, idx) => (
              <PartCard
                key={door.id}
                door={door}
                index={idx}
                doorStyles={doorStyles}
                stylesByCategory={stylesByCategory}
                units={units}
                onUpdate={onUpdateDoor}
                onDelete={onDeleteDoor}
                onViewImage={onViewImage}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
